import React from 'react';

import TeamCard from './TeamCard';

const TeamCards = ({ team }) => {
  if (!team?.length) {
    return <></>;
  };

  return (
    <div className="rs-team style2 team-home6-style pt-20 pb-20 md-pt-15 md-pb-15">
      <div className="row">
        {team.map(({ photo, name, title, social }, i) => (
          <TeamCard
            key={i}
            photo={photo}
            name={name}
            title={title}
            socialNetwork={social?.network}
            socialUrl={social?.url}
          />
        ))}
      </div>
    </div>
  );
};

export default TeamCards;
